import Dummy from "components/Dummy";
import P from "components/P";
import { motion, AnimatePresence } from "framer-motion";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import puffuLogo from "resources/login/Group.png";
import style from "./MobileMypage.module.css";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Inline from "layouts/container/Inline";
import CustomButton from "components/buttons/CustomButton";
import billIcon from "resources/img/vending/mypage/bill.png";
import boxIcon from "resources/img/vending/mypage/box.png";
import creditIcon from "resources/img/vending/mypage/credit.png";
import mapIcon from "resources/img/vending/mypage/map.png";
import Center from "layouts/wrapper/Center";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "providers/AuthProvider";
import { useNavigate, useParams } from "react-router-dom";
import { requester } from "App";
import SearchBar from "routes/front/header/SearchBar";

function MobileMypage() {
    const { userId, userName } = useContext(AuthContext);
    const { id } = useParams();
    const [orderList, setOrderList] = useState();
    const [isMounted, setMounted] = useState(false);
    const [point, setPoint] = useState(0);
    
    const navigate = useNavigate();

    const formatLocalDate = (isoDateString) => {
        const date = new Date(isoDateString);
        return date.toLocaleDateString('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).replace(/\. /g, '.').slice(0, -1);
    }


    useEffect(() => {
        
        if (userId) {
            let data = {
                storeId: id
            }
            requester.findAllPurchaseOrder(data, (result) => {

                setOrderList(result.data);
            })
        }


    }, [userId])


    const btnStyle = {
        backgroundColor: "var(--main-color)",
        color: "white",
        border: "none",
        fontSize: "14px",
        padding: "3px 12px"
    }
    const onReceiptClick = () => {
        navigate(`/ws/${id}/mobile/receipt`);
    }
    const onPointRechargeClick = () => {
        navigate(`/ws/${id}/pointRecharge`);
    }

    const OrderList = () => {

        const onReceiptDetailClick = (data) => {
            // NiceModal.show("receiptDetail", { data: data });
            navigate(`/ws/${id}/mobile/receipt/detail/${data.id}`, { state: { data: data } })
        }
        return (
            <VerticalFlex width={"90%"} gap={10} padding={10}>
                {
                    orderList &&
                        orderList.length > 0
                        ?
                        orderList.slice(0, 3).map((data, index) => (
                            <FlexChild>
                                <div onClick={() => onReceiptDetailClick(data)}>
                                    <VerticalFlex gap={15}>
                                        <FlexChild height={"max-content"}>
                                            <HorizontalFlex>
                                                <FlexChild width={"30%"}>
                                                    <img src={data.orderProducts[0].productImg} width={"50%"} />
                                                </FlexChild>
                                                <FlexChild>
                                                    <VerticalFlex>
                                                        <FlexChild>
                                                            <Center textAlign={"left"} width={"100%"}>
                                                                <P>{formatLocalDate(data.orderProducts[0].createDateTime)} 관저점</P>
                                                            </Center>
                                                        </FlexChild>
                                                        <FlexChild>
                                                            <Center textAlign={"left"} width={"100%"}>
                                                                <P>{data.orderProducts[0].productName} 외 {data.orderProducts.length - 1}건</P>
                                                            </Center>
                                                        </FlexChild>
                                                        <FlexChild>
                                                            <Center textAlign={"left"} width={"100%"}>
                                                                <P font={"gmarketSansBold"}>{data.amount ? data.amount.toLocaleString() : "0"}원</P>
                                                            </Center>
                                                        </FlexChild>
                                                    </VerticalFlex>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                        {
                                            index !== 2 &&
                                            <FlexChild width={"100%"} height={"1px"} backgroundColor={"#D9D9D9"} />
                                        }

                                    </VerticalFlex>
                                </div>
                            </FlexChild>

                        ))
                        :
                        <FlexChild>
                            <P>구입내역이 없습니다.</P>
                        </FlexChild>
                }
            </VerticalFlex>
        );
    }



    const Menu = () => {
        return (
            <div className={style.menuWrap}>
                <HorizontalFlex>
                    <FlexChild>
                        <div onClick={onReceiptClick}>
                            <VerticalFlex gap={10}>
                                <FlexChild>
                                    <img src={billIcon} />
                                </FlexChild>
                                <FlexChild>
                                    <P>영수증</P>
                                </FlexChild>
                            </VerticalFlex>
                        </div>
                    </FlexChild>
                    <FlexChild width={"2px"} height={"100%"} backgroundColor={"#F0F1F3"} />
                    <FlexChild>
                        <VerticalFlex gap={10}>
                            <FlexChild>
                                <img src={creditIcon} />
                            </FlexChild>
                            <FlexChild>
                                <P>결제수단</P>
                            </FlexChild>
                        </VerticalFlex>
                    </FlexChild>
                    <FlexChild width={"2px"} height={"100%"} backgroundColor={"#F0F1F3"} />
                    <FlexChild>
                        <VerticalFlex gap={10}>
                            <FlexChild>
                                <img src={boxIcon} />
                            </FlexChild>
                            <FlexChild>
                                <P>재고확인</P>
                            </FlexChild>
                        </VerticalFlex>
                    </FlexChild>
                    <FlexChild width={"2px"} height={"100%"} backgroundColor={"#F0F1F3"} />
                    <FlexChild>
                        <VerticalFlex gap={10}>
                            <FlexChild>
                                <img src={mapIcon} />
                            </FlexChild>
                            <FlexChild>
                                <P>매장찾기</P>
                            </FlexChild>
                        </VerticalFlex>
                    </FlexChild>
                </HorizontalFlex>
            </div>
        );
    }

    
    return (
        <div style={{ backgroundColor: "#F0F1F3" }}>
            <Dummy height={"50px"} />
            <VerticalFlex gap={30} >
                <FlexChild height={"max-content"} width={"90%"}>
                    <HorizontalFlex>
                        <FlexChild>
                            <Inline>
                                <P weight={"bold"} size={24}>{userName}</P>
                                <P weight={"bold"} size={24}> 님</P>
                            </Inline>
                        </FlexChild>
                        <FlexChild justifyContent={"flex-end"}>
                            {/* <P color={"var(--main-color)"} size={20} font={"gmarketSansBold"}>{point ? point.toLocaleString() : 0}P</P>
                            <Dummy width={"10px"} />
                            <CustomButton text={"충전"} style={btnStyle} onClick={onPointRechargeClick} /> */}
                            {/* <CustomButton text={"스캔"} style={btnStyle} onClick={onScanClick} /> */}
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                {/* <FlexChild width={"90%"} height={"max-content"}>
                    <Menu />
                </FlexChild> */}
                {/* <FlexChild height={"max-content"} width={"90%"}>
                    <SearchBar />
                </FlexChild> */}
                <FlexChild width={"90%"}>
                    <div style={{ backgroundColor: "white", borderRadius: "15px", padding: "10px" }}>
                        <VerticalFlex>
                            <FlexChild>
                                <HorizontalFlex width={"95%"} padding={"15px 10px"}>
                                    <FlexChild justifyContent={"center"}>
                                        <P size={16}>구입내역 (최근 3건)</P>
                                    </FlexChild>
                                    <FlexChild justifyContent={"flex-end"}>
                                        <P cursor onClick={onReceiptClick}>{">"}</P>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex>
                                    <FlexChild width={"90%"} height={"1px"} backgroundColor={"#D9D9D9"} />
                                    <FlexChild>
                                        <OrderList />
                                    </FlexChild>
                                </VerticalFlex>

                            </FlexChild>

                        </VerticalFlex>
                    </div>
                </FlexChild>
                <FlexChild height={"50px"} />
            </VerticalFlex>
            {/* <Dummy height={"12vh"} /> */}
        </div>
    );
}

export default MobileMypage;